// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"dc9d777b","977":"3b2d04a8"}[chunkId] + ".chunk.js";
};